import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment-timezone';

export interface CreateSession {
  acuityCalendarID?: number;
  acuityTypeID?: number;
  calendarDate?: Date;
  calendarMonth?: string;
}

const initialState: CreateSession = {
  calendarMonth: `${moment(new Date()).format('YYYY-MM')}`
};

const createSession = createSlice({
  name: 'createSession',
  initialState,
  reducers: {
    setAcuityCalendarID: (state, { payload }: PayloadAction<number>) => {
      state.acuityCalendarID = payload;
    },
    setAcuityTypeID: (state, { payload }: PayloadAction<number>) => {
      state.acuityTypeID = payload;
    },
    setCalendarDate: (state, { payload }: PayloadAction<Date>) => {
      state.calendarDate = payload;
    },
    setCalendarMonth: (state, { payload }: PayloadAction<string>) => {
      state.calendarMonth = payload;
    },
  },
});

export const { setAcuityCalendarID, setAcuityTypeID, setCalendarDate, setCalendarMonth } = createSession.actions;

export default createSession;
